import React from "react";
import commonTerms from "../../assets/img/commonTerms.png";
import {useTranslation} from "react-i18next";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserPrivacyPolicyPg() {

    const {t} = useTranslation();
    const [theme] = useTheme();

    const sections = [
        {h: 'ctpPpHd1', c: 'ctpPpCont1'},
        {h: 'ctpPpHd2', c: 'ctpPpCont2'},
        {h: 'ctpPpHd3', c: 'ctpPpCont3'},
        {h: 'ctpPpHd4', c: 'ctpPpCont4'},
        {h: 'ctpPpHd5', c: 'ctpPpCont5'},
        {h: 'ctpPpHd6', c: 'ctpPpCont6'},
    ];

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-doc-wrap">
                <div className="up-card">
                    <div className="up-doc-head">
                        <img className="up-invert" alt='' src={commonTerms}/>
                        <p className="t">{t('ctpPpHd')}</p>
                    </div>
                    <div className="up-doc-body">
                        <p className="up-doc-intro">{t('ctpPpcont')}</p>
                        {sections.map((s, i) => (
                            <div className="up-doc-sec" key={i}>
                                <h4>{t(s.h)}</h4>
                                <p>{t(s.c)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserPrivacyPolicyPg
